import { Api } from 'utils';

class PublicPaymentService {
	
	static get = async (params?: any) => Api.createResponse('public-payment',params);
	static save = async (params?: any) => Api.createResponse('public-payment/save',params);

}

export default PublicPaymentService;